import React, { useCallback } from 'react';
import { motion } from 'framer-motion';

import useAnimate from './primitives/Motion';

import Reveal from './primitives/Reveal';
import WordReveal from './primitives/WordReveal';
import { advantages } from '../data/site';

const EASE = [0.16, 1, 0.3, 1];

export default function Advantages() {
    const reduced = !useAnimate();

    // Feeds the pointer position to the card so its glow follows the cursor.
    const trackPointer = useCallback(event => {
        const rect = event.currentTarget.getBoundingClientRect();
        event.currentTarget.style.setProperty('--mx', `${event.clientX - rect.left}px`);
        event.currentTarget.style.setProperty('--my', `${event.clientY - rect.top}px`);
    }, []);

    return (
        <section className="section advantages" id="advantages">
            <div className="shell">
                <div className="section-head">
                    <Reveal y={18}>
                        <span className="t-eyebrow">Why the group</span>
                    </Reveal>
                    <WordReveal as="h2" className="t-h2" text="Comprehensive expertise for all your needs." />
                    <Reveal delay={0.12}>
                        <p className="t-lead">
                            Choosing The Smart Solutions Group means partnering with a leader across
                            electrical, low voltage, and interior construction. Here is what that buys you.
                        </p>
                    </Reveal>
                </div>

                <ul className="bento">
                    {advantages.map((item, i) => (
                        <motion.li
                            className="bento__card"
                            key={item.title}
                            onPointerMove={trackPointer}
                            initial={reduced ? false : { opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.25 }}
                            transition={{ duration: 0.75, delay: (i % 4) * 0.07, ease: EASE }}
                        >
                            <span className="bento__num">{String(i + 1).padStart(2, '0')}</span>
                            <h3 className="bento__title">{item.title}</h3>
                            <p className="bento__copy">{item.body}</p>
                        </motion.li>
                    ))}
                </ul>

                <Reveal delay={0.1} className="advantages__outro">
                    <p className="t-lead">
                        One streamlined, expertly managed approach to your electrical, low voltage,
                        and interior construction projects: the benefit of a genuinely integrated
                        service provider.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
